export * from '@primeuix/themes/nora/confirmdialog';
export { default } from '@primeuix/themes/nora/confirmdialog';
